import { CHECK_USER_RESPONSE_SCHEMA, CheckUserResponse } from '@/@core/models/api/iam';
import { HTTP_CLIENT_IAM } from '@/@core/services/api/httpClient';
import { handleRequestError } from '@/@core/services/api/utils/errorHandling';
import { validateResponseData } from '@/@core/services/api/utils/validateResponseData';
import { Http } from '@aleph-alpha/lib-http';

export class IamService {
  constructor(readonly httpClient: Http) {}

  async checkUser(permissions: string[]): Promise<CheckUserResponse> {
    const response = await handleRequestError(
      async () =>
        await this.httpClient.post<CheckUserResponse>('check_user', {
          body: {
            permissions: permissions.map((p) => ({
              permission: p,
            })),
          },
        })
    );
    return await validateResponseData(response, CHECK_USER_RESPONSE_SCHEMA);
  }
}

export const IAM_SERVICE = new IamService(HTTP_CLIENT_IAM);
